module.exports = __webpack_public_path__ + "static/media/cloud.4be54a28.svg";